<form
    #driveForm="ngForm"
    *ngIf="myItem && myConfiguration && urlEndPoint.includes('drive')"
    class="needs-validation container"
>
    <!-- ==========  TRIAL  ========== -->
    <!-- <div class="drive__step"
        #step1
        *ngIf="canTrial">
         <div class="step step--1"
            *ngIf="canTrial">
            <div class="step__container">
                <div class="step__title">
                    <h2> {{ "Comment souhaitez-vous commencer avec le Drive ?" | transloco }} </h2>
                </div>
                <div class="step__content">
                    <ng-template #slideshowStep1>
                        <div class="col-12 col-sm-6 col-lg-4"
                            [ngClass]="displaySlideshow ? 'swiper-slide' : ''">
                            <div class="card">
                                <div class="card__body card__body--actions">
                                    <div class="card__title text-center">{{ 'Tester gratuitement la version beta $day$ jours' | transloco:{day: nb_jour_beta} }} </div>
                                    <div class="block-buttons align-center">
                                        <button *ngIf="myItem.attributes.trial === false || myItem.attributes.trial === null"
                                            mat-stroked-button
                                            color="primary"
                                            (click)="myItem.attributes.trial = true; scroll(step2)"
                                            class="btn-block"
                                            [disabled]="loading"> <span *ngIf="!loading; else loaderButton"></span><span *ngIf="!loading">{{'CHOISIR' | transloco}} </span> </button>
                                        <button *ngIf="myItem.attributes.trial === true"
                                            mat-flat-button
                                            color="primary"
                                            (click)="scroll(step2)"
                                            class="btn-block"
                                            [disabled]="loading">
                                            <span class="icon icon-check icon-size-12 white"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4"
                            [ngClass]="displaySlideshow ? 'swiper-slide' : ''"
                            *ngIf="false">
                            <div class="card">
                                <div class="card__body card__body--actions">
                                    <div class="card__title text-center">
                                        <div class="card__label"
                                            >Souscrire des maintenant</div>
                                        <div class="card__pricing"
                                            *ngIf="minimumPrice"
                                            [innerHTML]=" 'des $price$' | transloco:{price : (minimumPrice | mycurrency :false:'':' ' + ('/mois' | transloco):['price']:['price--amount']) }"> </div>
                                    </div>
                                    <div class="block-buttons align-center">
                                        <button mat-stroked-button
                                            color="primary"
                                            *ngIf="myItem.attributes.trial === true || myItem.attributes.trial === null"
                                            (click)="myItem.attributes.trial = false; scroll(step2)"
                                            class="btn-block"
                                            [disabled]="loading"> <span *ngIf="!loading; else loaderButton"></span><span *ngIf="!loading">{{'CHOISIR' | transloco }} </span> </button>
                                        <button *ngIf="myItem.attributes.trial === false"
                                            mat-flat-button
                                            color="primary"
                                            (click)="scroll(step2)"
                                            class="btn-block"
                                            [disabled]="loading">
                                            <span class="icon icon-check icon-size-12 white"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <div class="row justify-content-sm-center">
                        <div class="slideshow relative">
                            <div class="row justify-content-sm-center"
                                *ngIf="!displaySlideshow">
                                <ng-container *ngTemplateOutlet="slideshowStep1"></ng-container>
                            </div>
                            <div *ngIf="displaySlideshow">
                                <div class="swiper-container"
                                    [swiper]="configStep1"
                                    [(index)]="indexStep1">
                                    <div class="swiper-wrapper">
                                        <ng-container *ngTemplateOutlet="slideshowStep1"></ng-container>
                                    </div>
                                    <div class="swiper-pagination"></div>
                                </div>
                                <div class="swiper-button-prev prev-step1">
                                    <span class="icon icon-chevron-left icon-size-10"></span>
                                </div>
                                <div class="swiper-button-next next-step1">
                                    <span class="icon icon-chevron-right icon-size-10"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="step step--1"
            *ngIf="!canTrial">
            <div>
                <div class="custom-alert">
                    <div class="custom-alert__content">
                        <p>
                            <span class="icon icon-warning icon-size-24 orange"></span>
                            <span> {{ 'Vous avez deja utilise la version de beta gratuite $num$ jours avec ce compte' | transloco: {num: nb_jour_beta} }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- ==========PACK========== -->
    <div class="drive__step" id="step2">
        <div class="step step--2">
            <div class="step__container">
                <div class="step__title">
                    <h2 *ngIf="!conf?.setup?.offer_label">
                        {{ "Choisissez l'offre dont vous avez besoin" | transloco }}
                    </h2>
                    <h2 *ngIf="conf?.setup?.offer_label">{{ conf?.setup?.offer_label }}</h2>
                    <div *ngIf="myConfiguration?.period?.values?.entries" class="periodselector">
                        <div class="periodselector__container">
                            <button
                                (click)="loading ? null : setPeriod(1)"
                                [class.periodselector__btn--selected]="myItem.attributes.period === 1"
                                [ngClass]="getPeriodClasses('1')"
                            >
                                {{ '1 MOIS' | transloco }}
                            </button>
                            <button
                                (click)="loading ? null : setPeriod(12)"
                                [class.periodselector__btn--selected]="myItem.attributes.period === 12"
                                [ngClass]="getPeriodClasses('12')"
                            >
                                {{ '1 AN' | transloco }}
                                <span [class.flash]="myItem.attributes.period !== 12" class="icon-star2"></span>
                                <div class="promo-label">{{ '-' + getPromo('period', 12) }}</div>
                            </button>
                            <button
                                (click)="loading ? null : setPeriod(24)"
                                [class.periodselector__btn--selected]="myItem.attributes.period === 24"
                                [ngClass]="getPeriodClasses('24')"
                            >
                                {{ '2 ANS' | transloco }}
                                <div class="promo-label">{{ '-' + getPromo('period', 24) }}</div>
                            </button>
                            <button
                                (click)="loading ? null : setPeriod(36)"
                                [class.periodselector__btn--selected]="myItem.attributes.period === 36"
                                [ngClass]="getPeriodClasses('36')"
                            >
                                {{ '3 ANS' | transloco }}
                                <div class="promo-label">{{ '-' + getPromo('period', 36) }}</div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="step__content">
                    <div class="relative">
                        <div class="row justify-content-sm-center">
                            <!-- <div class="col-12"> -->
                            <div class="slideshow relative">
                                <div [swiper]="configStep2" class="swiper-container">
                                    <div class="swiper-wrapper">
                                        <div
                                            *ngFor="let option of pack"
                                            class="swiper-slide col-lg-3 col-sm-6 option--{{
                                                option.id
                                            }} pack-swipper-option"
                                        >
                                            <div class="card card--full card--offer">
                                                <div class="card__header">
                                                    <div class="disk__offer disk__offer--padded">
                                                        <img
                                                            [src]="'/assets/images/drive/pack_' + option.id + '.svg'"
                                                        />
                                                        {{ option.name }}
                                                    </div>
                                                    <div
                                                        *ngIf="myItem.attributes.trial || option.id === 0"
                                                        class="disk__price"
                                                    >
                                                        <div class="title">{{ 'Gratuit' | transloco }}</div>
                                                        <div
                                                            *ngIf="option.id !== 0"
                                                            [innerHTML]="
                                                                {
                                                                    amount: getPrice('pack', option.id),
                                                                    textAfter:
                                                                        option.id === 3
                                                                            ? ('/mois /utilisateur' | transloco)
                                                                            : ('/mois' | transloco),
                                                                    textBefore:
                                                                        getLabelDays(nb_jour_beta) +
                                                                        ' ' +
                                                                        ('puis' | transloco),
                                                                    amountDisplay: 'medium'
                                                                } | mycurrency
                                                            "
                                                            class="description"
                                                        ></div>
                                                    </div>
                                                    <div
                                                        *ngIf="!myItem.attributes.trial && option.id !== 0"
                                                        [innerHTML]="
                                                            {
                                                                amount: getPrice('pack', option.id),
                                                                textAfter:
                                                                    option.id === 3
                                                                        ? ('/mois /utilisateur' | transloco)
                                                                        : ('/mois' | transloco)
                                                            } | mycurrency
                                                        "
                                                        class="disk__price"
                                                    ></div>
                                                    <div class="label_user">
                                                        <div
                                                            *ngFor="let line of packSettings.get(option.id)"
                                                            [innerHTML]="line"
                                                        ></div>
                                                    </div>
                                                </div>
                                                <div class="card__body card__body--actions align-left p-0">
                                                    <div class="card__body__selection">
                                                        <ng-container *ngIf="option.id !== 0">
                                                            <div
                                                                *ngIf="canTrial && !forceTrial"
                                                                class="block-buttons text-center relative"
                                                            >
                                                                <button
                                                                    (click)="
                                                                        resetDrive();
                                                                        myItem.attributes.pack_id = option.id;
                                                                        updateMyItem(false);
                                                                        scrollWizard('step2')
                                                                    "
                                                                    *ngIf="myItem.attributes.pack_id !== option.id"
                                                                    [disabled]="loading"
                                                                    class="btn-block"
                                                                    color="primary"
                                                                    data-testid="btn-trial"
                                                                    mat-stroked-button
                                                                >
                                                                    <span *ngIf="!loading; else loaderButton"></span>
                                                                    <span
                                                                        *ngIf="
                                                                            !loading &&
                                                                            (myItem.attributes.trial === 1 ||
                                                                                myItem.attributes.trial === null ||
                                                                                myItem.attributes.trial === true)
                                                                        "
                                                                        class="touppercase"
                                                                        >{{
                                                                            'tester $nb$ jours' | transloco : { nb: 30 }
                                                                        }}
                                                                    </span>
                                                                    <span
                                                                        *ngIf="
                                                                            !loading &&
                                                                            (myItem.attributes.trial === 0 ||
                                                                                myItem.attributes.trial === false)
                                                                        "
                                                                        >{{ 'SOUSCRIRE DES MAINTENANT' | transloco }}
                                                                    </span>
                                                                </button>
                                                                <button
                                                                    (click)="scrollWizard('step2')"
                                                                    *ngIf="myItem.attributes.pack_id === option.id"
                                                                    [disabled]="loading"
                                                                    class="btn-block"
                                                                    color="primary"
                                                                    mat-flat-button
                                                                >
                                                                    <span
                                                                        class="icon icon-check icon-size-12 white"
                                                                    ></span>
                                                                    <span class="touppercase">
                                                                        {{
                                                                            myItem.attributes.trial === 1 ||
                                                                            myItem.attributes.trial === null ||
                                                                            myItem.attributes.trial === true
                                                                                ? ('tester $nb$ jours'
                                                                                  | transloco : { nb: 30 })
                                                                                : ('SOUSCRIRE DES MAINTENANT'
                                                                                  | transloco)
                                                                        }}
                                                                    </span>
                                                                </button>
                                                            </div>
                                                            <div
                                                                (click)="
                                                                    myItem.attributes.trial = 0;
                                                                    myItem.attributes.pack_id = option.id;
                                                                    updateMyItem();
                                                                    scrollWizard('step2')
                                                                "
                                                                *ngIf="
                                                                    !forceTrial &&
                                                                    canTrial &&
                                                                    (myItem.attributes.trial === 1 ||
                                                                        myItem.attributes.trial === null ||
                                                                        myItem.attributes.trial === true)
                                                                "
                                                                class="card__body__selection__alternative"
                                                            >
                                                                {{ 'ou' | transloco }}
                                                                <span class="link blue">{{
                                                                    'souscrire des maintenant' | transloco
                                                                }}</span>
                                                            </div>
                                                            <div
                                                                (click)="
                                                                    myItem.attributes.trial = 1;
                                                                    myItem.attributes.pack_id = option.id;
                                                                    updateMyItem();
                                                                    scrollWizard('step2')
                                                                "
                                                                *ngIf="
                                                                    !forceTrial &&
                                                                    canTrial &&
                                                                    (myItem.attributes.trial === 0 ||
                                                                        myItem.attributes.trial === false)
                                                                "
                                                                class="card__body__selection__alternative"
                                                            >
                                                                {{ 'ou' | transloco }}
                                                                <span class="link blue">{{
                                                                    'tester $nb$ jours' | transloco : { nb: 30 }
                                                                }}</span>
                                                            </div>
                                                            <div
                                                                *ngIf="!canTrial || forceTrial"
                                                                class="block-buttons text-center relative"
                                                            >
                                                                <button
                                                                    (click)="
                                                                        resetDrive();
                                                                        myItem.attributes.pack_id = option.id;
                                                                        updateMyItem(false, true);
                                                                        myItem.attributes.trial = toNumber(forceTrial);
                                                                        scrollWizard('step2')
                                                                    "
                                                                    *ngIf="myItem.attributes.pack_id !== option.id"
                                                                    [disabled]="loading"
                                                                    class="btn-block"
                                                                    color="primary"
                                                                    mat-stroked-button
                                                                >
                                                                    <span *ngIf="!loading; else loaderButton"></span
                                                                    ><span *ngIf="!loading"
                                                                        >{{ 'CHOISIR' | transloco }}
                                                                    </span>
                                                                </button>
                                                                <button
                                                                    (click)="
                                                                        scrollWizard('step2');
                                                                        myItem.attributes.trial = toNumber(forceTrial)
                                                                    "
                                                                    *ngIf="myItem.attributes.pack_id === option.id"
                                                                    [disabled]="loading"
                                                                    class="btn-block"
                                                                    color="primary"
                                                                    mat-flat-button
                                                                >
                                                                    <span
                                                                        class="icon icon-check icon-size-12 white"
                                                                    ></span>
                                                                </button>
                                                            </div>
                                                        </ng-container>
                                                        <div
                                                            *ngIf="option.id === 0"
                                                            class="block-buttons text-center relative"
                                                        >
                                                            <button
                                                                (click)="goToMyKsuite()"
                                                                class="btn-block"
                                                                color="primary"
                                                                mat-stroked-button
                                                            >
                                                                <span class="touppercase"
                                                                    >{{ 'CHOISIR' | transloco : { nb: 30 } }}
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="margin-top-20">
                                                        <ul class="list list--check">
                                                            <li
                                                                class="list__item"
                                                                *ngFor="let line of packDescription.get(option.id)"
                                                            >
                                                                <span
                                                                    [innerHTML]="line.description"
                                                                    class="list__item__description"
                                                                ></span>
                                                                <span
                                                                    *ngIf="!!line.tooltip"
                                                                    [tooltip]="line.tooltip"
                                                                    class="icon icon-information list__item__tooltip-icon"
                                                                    tooltipClass="custom-tooltip custom-tooltip--compact"
                                                                ></span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div *ngIf="isStared('pack_id', option.id)" class="stared-option">
                                                    <div class="stared-icon"><span class="icon icon-star2"></span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-pagination"></div>
                                </div>
                                <div class="swiper-button-prev prev-step2">
                                    <span class="icon icon-chevron-left icon-size-10"></span>
                                </div>
                                <div class="swiper-button-next next-step2">
                                    <span class="icon icon-chevron-right icon-size-10"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ========== USER NUMBER ========== -->
    <div class="drive__step drive-step" id="drive-step">
        <div
            *ngIf="
                (myItem.attributes.pack_id === 2 || myItem.attributes.pack_id === 3) &&
                myConfiguration &&
                myConfiguration.user_nb &&
                myConfiguration.user_nb.min
            "
            class="step step--3"
        >
            <div class="step__container step3" id="step3">
                <div class="step__title">
                    <h2>{{ "Combien d'utilisateur avez-vous besoin ?" | transloco }}</h2>
                </div>
                <div class="row justify-content-sm-center">
                    <div class="col-12 col-sm-6 col-lg-4">
                        <div class="card card--full">
                            <div class="card__body card__body--actions text-center">
                                <div class="disk text-center">
                                    <div class="actions__wrapper">
                                        <button
                                            (click)="incrementUserNb(-1)"
                                            color="accent"
                                            [disabled]="loading || matInputValue === matInputConfig.min"
                                            class="disk__button actions__button"
                                            mat-flat-button
                                        >
                                            <span class="actions__button--less"></span>
                                        </button>
                                        <input
                                            (change)="incrementUserNb(0)"
                                            (input)="incrementUserNb(0)"
                                            [(ngModel)]="matInputValue"
                                            [disabled]="loading"
                                            [max]="matInputConfig.max"
                                            [min]="matInputConfig.min"
                                            class="mat-slider actions__input"
                                            matInput
                                            name="usernbInput"
                                        />
                                        <button
                                            (click)="incrementUserNb(1)"
                                            color="accent"
                                            [disabled]="loading || matInputValue === matInputConfig.max"
                                            class="disk__button actions__button"
                                            mat-flat-button
                                        >
                                            +
                                        </button>
                                    </div>
                                    <div
                                        *ngIf="matInputConfig.min && matInputValue < matInputConfig.min"
                                        class="red padding-bottom-10"
                                    >
                                        {{
                                            "L'offre choisit requiert au minimum $nbUser$ utilisateurs."
                                                | transloco : { nbUser: matInputConfig.min }
                                        }}
                                    </div>
                                    <app-max-user-commercial-contact
                                        *ngIf="matInputConfig.max && matInputValue >= matInputConfig.max"
                                        [maxUsers]="matInputConfig.max"
                                    ></app-max-user-commercial-contact>
                                    <div
                                        *ngIf="
                                            matInputValue >= matInputConfig.min && matInputValue <= matInputConfig.max
                                        "
                                        [innerHTML]="
                                            getPrice('user_nb', matInputValue).amountVAT === 0
                                                ? '<span class=\'slot-number\'>' + ('Inclus' | transloco) + '</span>'
                                                : ({
                                                      amount: getPrice('user_nb', matInputValue),
                                                      textAfter: ('/mois' | transloco)
                                                  } | mycurrency)
                                        "
                                        class="padding-bottom-30"
                                    ></div>
                                </div>
                                <div class="block-buttons align-center">
                                    <button
                                        (click)="
                                            changingInput = false;
                                            myItem.attributes.user_nb = matInputValue;
                                            updateMyItem(false, true);
                                            scrollWizard('step3')
                                        "
                                        mat-stroked-button
                                        color="primary"
                                        [disabled]="loading || matInputValue > matInputConfig.max"
                                        *ngIf="myItem.attributes.user_nb !== matInputValue || changingInput"
                                        class="btn-block"
                                    >
                                        <span *ngIf="!loading; else loaderButton"></span
                                        ><span *ngIf="!loading">{{ 'CHOISIR' | transloco }} </span>
                                    </button>
                                    <button
                                        (click)="updateMyItem(false, true); scrollWizard('step3')"
                                        mat-flat-button
                                        color="primary"
                                        [disabled]="loading"
                                        *ngIf="myItem.attributes.user_nb === matInputValue && !changingInput"
                                        class="btn-block"
                                    >
                                        <span class="icon icon-check icon-size-12 white"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ========== DISK SIZE ========== -->
    <div class="drive__step" id="step4">
        <div
            *ngIf="
                (myItem.attributes.pack_id === 2 ||
                    (myItem.attributes.pack_id === 3 &&
                        myItem.attributes.user_nb &&
                        matInputValue <= matInputConfig.max)) &&
                myConfiguration &&
                myConfiguration.disk_size &&
                myConfiguration.disk_size.values
            "
            class="step step--4"
        >
            <div class="step__container">
                <div class="step__title">
                    <h2>{{ "Quelle capacite d'espace de stockage avez-vous besoin ?" | transloco }}</h2>
                </div>
                <div class="row justify-content-sm-center">
                    <div class="col-12 col-sm-6 col-lg-4">
                        <div class="card card--full">
                            <div class="card__body card__body--actions text-center">
                                <div class="disk text-center full-width">
                                    <div>
                                        <div>
                                            <span class="disk__label">{{ getDiskSizeLabel(matSliderValue) }}</span>
                                            <span class="disk__size">{{ 'To' | size }}</span>
                                        </div>
                                        <div class="actions__wrapper">
                                            <button
                                                (click)="incrementDiskSize(-1)"
                                                color="accent"
                                                [disabled]="loading || matSliderValue === matSliderConfig.min"
                                                class="disk__button actions__button"
                                                mat-flat-button
                                            >
                                                <span class="actions__button--less"></span>
                                            </button>
                                            <mat-slider
                                                (change)="incrementDiskSize(0)"
                                                (input)="onDiskSizeChange($event)"
                                                [color]="'primary'"
                                                [disabled]="loading"
                                                [max]="matSliderConfig.max"
                                                [min]="matSliderConfig.min"
                                                [step]="matSliderConfig.step"
                                                [tickInterval]="'auto'"
                                                [value]="
                                                    matSliderValue < matSliderConfig.min
                                                        ? matSliderConfig.min
                                                        : matSliderValue
                                                "
                                                class="mat-slider actions__slider"
                                            >
                                            </mat-slider>
                                            <button
                                                (click)="incrementDiskSize(1)"
                                                color="accent"
                                                [disabled]="loading || matSliderValue === matSliderConfig.max"
                                                class="disk__button actions__button"
                                                mat-flat-button
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        [innerHTML]="
                                            getPrice('disk_size', matSliderValue)?.incl_vat === 0
                                                ? '<span
                                               class=\'slot-number\'>' +
                                                  ('Inclus' | transloco) +
                                                  '</span>'
                                                : ({
                                                      amount: getPrice('disk_size', matSliderValue),
                                                      textAfter: ('/mois' | transloco)
                                                  } | mycurrency)
                                        "
                                        class="padding-bottom-30"
                                    ></div>
                                </div>
                                <div class="block-buttons align-center">
                                    <button
                                        (click)="
                                            changingDiskSize = false;
                                            myItem.attributes.disk_size = matSliderValue;
                                            updateMyItem(false, true);
                                            scrollWizard('step4')
                                        "
                                        mat-stroked-button
                                        color="primary"
                                        [disabled]="loading"
                                        *ngIf="myItem.attributes.disk_size !== matSliderValue || changingDiskSize"
                                        class="btn-block"
                                    >
                                        <span *ngIf="!loading; else loaderButton"></span
                                        ><span *ngIf="!loading">{{ 'CHOISIR' | transloco }} </span>
                                    </button>
                                    <button
                                        (click)="updateMyItem(false, true); scrollWizard('step4')"
                                        mat-flat-button
                                        color="primary"
                                        [disabled]="loading"
                                        *ngIf="myItem.attributes.disk_size === matSliderValue && !changingDiskSize"
                                        class="btn-block"
                                    >
                                        <span class="icon icon-check icon-size-12 white"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ========== NAME PREFIX ========== -->
    <div class="drive__step" id="step5">
        <div
            *ngIf="
                myItem.attributes.pack_id === 1 ||
                (myItem.attributes.pack_id === 2 && myItem.attributes.disk_size) ||
                (myItem.attributes.pack_id === 3 && myItem.attributes.user_nb && myItem.attributes.disk_size)
            "
            class="step step--5"
        >
            <div class="step__container">
                <div class="step__title">
                    <h2>{{ 'Choisissez un nom pour votre kDrive' | transloco }}</h2>
                </div>
                <div class="step__title padding-bottom-20">
                    <p class="grey-darken-3">
                        {{
                            "Ce nom apparaitra dans votre console d'administration et dans les applications."
                                | transloco
                        }}
                    </p>
                </div>
                <div class="row justify-content-sm-center">
                    <div class="col-12 col-sm-6 col-lg-4">
                        <div class="card card--full">
                            <div class="card__body card__body--actions">
                                <div class="disk text-center full-width">
                                    <div>
                                        <mat-form-field appearance="outline" class="drive-prefix">
                                            <input
                                                #drivePrefixEl
                                                name="drivePrefixEl"
                                                (keydown.enter)="$event.preventDefault(); setName($event.target)"
                                                [disabled]="loading"
                                                [placeholder]="defaultDrivePrefix"
                                                [value]="myItem.attributes.prefix_name || null"
                                                matInput
                                                required
                                                type="text"
                                            />
                                            <app-loader
                                                *ngIf="loading"
                                                [size]="15"
                                                class="drive-input-loader"
                                            ></app-loader>
                                        </mat-form-field>
                                        <span class="label_user">{{ suffix_name }}</span>
                                    </div>
                                </div>
                                <div class="block-buttons align-center">
                                    <button
                                        *ngIf="drivePrefixEl.value !== myItem.attributes.prefix_name"
                                        mat-stroked-button
                                        color="primary"
                                        (click)="setName(drivePrefixEl)"
                                        class="btn-block"
                                        data-testid="btn-validate-drive-name"
                                        [disabled]="loading || drivePrefixEl.value === null"
                                    >
                                        <span *ngIf="!loading; else loaderButton"></span>
                                        <span *ngIf="!loading">{{ 'VALIDER' | transloco }}</span>
                                    </button>
                                    <button
                                        *ngIf="myItem.attributes.prefix_name === drivePrefixEl.value"
                                        mat-flat-button
                                        color="primary"
                                        (click)="updateMyItem()"
                                        class="btn-block"
                                        [disabled]="loading"
                                    >
                                        <span class="icon icon-check icon-size-12 white"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
<ng-template #loader>
    <app-loader [size]="15"></app-loader>
</ng-template>
<ng-template #spacer>
    <div class="mt-5"></div>
</ng-template>
<ng-template #loaderButton>
    <div class="loader__init js-loader-init">
        <div class="loader__anim bg-blue"></div>
        <div class="loader__anim bg-blue-darken-3"></div>
        <div class="loader__anim bg-blue-lighten-1"></div>
    </div>
</ng-template>
